<template>
  <div class="post-list" ref="listWrap">
    <div
      class="colume-list"
      v-for="(list, index) in listSet"
      :key="index"
      ref="columnList"
    >
      <div
        class="post-item"
        v-for="(item, index) in list"
        :key="index"
        @click="detail(item)"
      >
        <div class="cover">
          <van-image
            class="img"
            width="100%"
            :src="resizePicture(item.coverImg)"
            :style="item.coverImgStyle"
            alt=""
            fit="cover"
          />
          <div v-if="item.dynamicStatus === 0" class="admit">审核中</div>
          <div v-if="item.dynamicStatus === 2" class="admit">审核未通过</div>
          <img
            v-if="item.dynamicType === 1"
            src="@/assets/image/club/icon-play-r.png"
            class="icon-play"
          />
        </div>
        <div class="title">{{ item.dynamicTitle }}</div>
        <div class="user">
          <club-avatar
            :src="item.user.photo"
            :isCardUser="item.user.isMgc === 1"
            size="size18"
          />
          <div class="name">{{ item.user.nickName }}</div>
          <div class="like" :class="item.hasPraise ? 'current' : ''">
            {{ transforPraiseNum(item.praiseNum) }}
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div v-if="loading" class="tip-loading">加载中…</div>
    <div v-if="noMoreData && postList.length" class="tip-no-more">
      没有更多了
    </div>
    <div v-if="noMoreData && postList.length === 0">
      <slot name="empty"></slot>
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
import { statClick, statShow } from "@/utils/h5-report";
import { getQuery } from "@/utils/url";
import { transforPraiseNum } from "../../utils/utils";
import { mapState } from "vuex";
import ClubAvatar from "./club-avatar.vue";
import getConfig from "../../config/index";
import { Toast } from "vant";

export default {
  name: "PostList",
  components: { ClubAvatar, VanImage },
  props: {
    // 帖子数据
    postList: {
      type: Array, // as Post[]
      default: () => [],
    },
    newTab: {
      type: Boolean,
      default: true,
    },
    // 是否是在 我的 tab中
    isProfile: {
      type: Boolean,
      default: false,
    },
    // 是否是在 我的 tab中
    autoLoad: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      listSet: [[], []],
      listHeight: [0, 0],
      loading: false,
      noMoreData: false,
      page: 0,
      pageSize: 10,
    };
  },
  watch: {
    postList: {
      handler(newPosts, oldPosts) {
        this.loading = false;
        if (newPosts && oldPosts && newPosts.length === oldPosts.length) {
          this.noMoreData = true;
          console.log("到底了, 一共 ", newPosts.length);
        }

        // 计算新增的posts
        const oldLength = (oldPosts || []).length;
        const newItems = newPosts.slice(oldLength);
        if (!newItems.length) return;

        // 先拿到左右列表已有的高度
        const columns = this.$refs.columnList;
        if (columns) {
          this.listHeight = [columns[0].offsetHeight, columns[1].offsetHeight];
        }

        // 将新增的item逐个添加到较短的列中
        newItems.forEach((item) => {
          let height = 0;

          // 根据帖子类型计算高度和封面信息
          if (item.dynamicType === 1) {
            // 视频帖：固定尺寸
            height = 226;
            item.coverImg = item.video.verticalImg;
            item.coverImgStyle = { width: "1.7rem", height: "2.26rem" };
          } else {
            // 图文帖：动态计算尺寸
            const coverImage = item.images[0];
            const { width, height: imgHeight } = coverImage;
            height = this.computeSize(width, imgHeight).height;
            item.coverImg = coverImage.path;
            item.coverImgStyle = this.computeStyle(width, imgHeight);
          }

          // 计算标题高度并累加（超过11字符显示两行）
          height += item.dynamicTitle.length > 11 ? 43.67 : 24.95;

          // 添加到较短的列
          const targetCol = this.listHeight[0] <= this.listHeight[1] ? 0 : 1;
          this.listSet[targetCol].push(item);
          this.listHeight[targetCol] += height;
        });
        setTimeout(() => {
          // 数据曝光上报
          statShow(
            {
              smod: "post_card",
              sids: newItems.map((n) => n.dynamicId).join("#"),
              plist: newItems.map((n, i) => i + oldLength + 1).join("#"),
            },
            {
              flag: 600,
            },
          );
        }, 300);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    if (this.autoLoad) {
      this.loadPost();
    }
    this.initScrollListener();
  },
  beforeDestroy() {
    this.destroyScrollListener();
  },
  methods: {
    resizePicture(url) {
      if (url.indexOf("?") === -1) {
        return (url += `?x-oss-process=image/resize,w_375,q_80/format,jpg`);
      } else {
        return url;
      }
    },
    detail(item) {
      statClick(
        {
          actid: getQuery("activityId"),
          post_id: item.dynamicId,
        },
        {
          cont: "点击单帖卡片",
          mod: "post_card",
        },
      );

      let url = "";
      if (item.dynamicType === 1) {
        if (item.dynamicStatus != 1) {
          Toast("视频正在审核中，无法查看");
          return;
        }
        // 跳视频播放页
        url = `${
          getConfig().clubHomeUrl
        }?cxid=mgcardclub0212&activityId=1a1b7e9f9823a8d5&channelId=64cb87b3937669c3#/club/video/${
          item.dynamicId
        }`;
      } else {
        // 跳图文详情页
        url = `${
          getConfig().clubHomeUrl
        }?activityId=c3eb5cc10c8b709c&_env=DEV&_cst=vconsole#/club/detail/${
          item.dynamicId
        }`;
      }
      this.$nextTick(() => {
        window.location.href = url;
      });
    },

    computeSize(width, height) {
      let rate = width / 170;
      width = 170;
      height = height / rate;

      // 详情页需求：宽度固定750px，高度最大1000px，根据宽度，高度做等比自适应。图片最大的尺寸是750x1000，宽度永远750，高度是1000到0
      // 列表页参照详情页等比缩放后，设定最大高度裁剪显示
      const maxHeight = (170 / 750) * 1000;
      if (height > maxHeight) height = maxHeight;

      return { width, height };
    },
    computeStyle(width, height) {
      let size = this.computeSize(width, height);
      return {
        width: size.width / 100 + "rem",
        height: size.height / 100 + "rem",
      };
    },
    initScrollListener() {
      // 父元素需要是包含滚动条的元素，这样才能在滚动的时候触发加载
      window.addEventListener("scroll", this.scrollListener);
    },
    destroyScrollListener() {
      window.removeEventListener("scroll", this.scrollListener);
    },
    scrollListener() {
      let scrollTop = window.pageYOffset;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;

      if (scrollTop + clientHeight >= scrollHeight - 500) {
        this.loadPost();
      }
    },
    loadPost() {
      if (!this.loading && !this.noMoreData) {
        this.loading = true;
        this.page++;
        this.$emit("load-post", this.page, this.pageSize);
      }
    },
    reset() {
      this.$nextTick(() => {
        this.listSet = [[], []];
        this.listHeight = [0, 0];
        this.loading = false;
        this.noMoreData = false;
        this.page = 0;
        this.$nextTick(() => {
          this.loadPost();
        });
      });
    },
    transforPraiseNum(number) {
      return transforPraiseNum(number);
    },
  },
};
</script>

<style lang="less" scoped>
.post-list {
  padding: 10px 15px 30px 15px;

  .clear {
    clear: both;
  }

  .colume-list {
    float: left;
    &:first-child {
      margin-right: 5px;
    }

    .post-item {
      width: 170px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      margin-bottom: 5px;
      .cover {
        width: 170px;
        position: relative;
        .img {
          overflow: hidden;
          display: block;
          border-radius: 15px 15px 0 0;
          object-fit: cover;
          background-color: #ddd;
        }
        .admit {
          background: linear-gradient(
            135deg,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0.3) 100%
          );
          position: absolute;
          left: 10px;
          bottom: 5px;
          max-width: 170px - 10px - 10px - 6px - 6px;
          line-height: 18px;
          padding: 0 6px;
          font-size: 10px;
          color: #fff;
          border-radius: 9px;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          max-height: 36px;
        }
        .icon-play {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          position: absolute;
          top: 7px;
          right: 7px;
        }
      }
      .title {
        background: #fff;
        padding: 0 10px;
        padding-top: 6px;
        color: rgba(0, 26, 51, 1);
        font-size: 13px;
        line-height: 18px;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        max-height: 36px;
      }
      .user {
        background: #fff;
        border-radius: 0 0 15px 15px;
        padding: 6px 0 10px 10px;
        display: flex;
        align-items: center;
        .name {
          padding-left: 6px;
          color: rgba(0, 26, 53, 0.5);
          font-size: 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex-shrink: 1;
          overflow: hidden;
          width: 100%;
        }
        .like {
          padding-left: 10px;
          padding-right: 10px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          &:before {
            content: "";
            width: 13px;
            height: 13px;
            background: no-repeat center center;
            background-image: url("../../assets/image/club/list-like.png");
            background-size: contain;
            margin-right: 2px;
          }
          color: rgba(0, 26, 53, 0.5);
          font-size: 10px;

          &.current {
            &:before {
              background-image: url("../../assets/image/club/list-like-current.png");
            }
          }
        }
      }
    }
  }

  .tip-loading {
    padding: 30px 0;
    padding-bottom: 0;
    color: rgba(0, 26, 53, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;

    &:before {
      content: "";
      width: 20px;
      height: 20px;
      background: no-repeat center center;
      background-image: url("../../assets/image/club/loading.png");
      background-size: contain;
      margin-right: 2px;
      margin-right: 10px;
      animation: rotate 1s linear infinite;
    }
  }
  .tip-no-more {
    padding: 30px 0;
    padding-bottom: 0;
    color: rgba(0, 26, 53, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
